import React from 'react';
import Badge from 'react-bootstrap/Badge';
import knowledgeData from '../../settings/knowledge.json';
import './KnowledgeViewer.scss';


const KnowledgeViewer: React.FC = () => {
  const k: any = knowledgeData as any;

  return (
    <div className="knowledge-viewer">
      <div className="mb-3">
        <strong>{k.summary}</strong>
        <div className="text-muted small">
          Updated: {k.lastUpdated} • ExperienceYears: {k.experienceYears}
        </div>
      </div>

      <section className="mb-3 compact-section">
        <h6>Skills</h6>
        <div className="d-flex flex-wrap">
          {Array.isArray(k.skills) &&
            k.skills.map((s: any, idx: number) => (
              <Badge bg="light" key={idx} className="me-1 mb-1 compact-badge text-dark">
                {s.name} <small className="text-muted">{`(${s.level}/5)`}</small>
              </Badge>
            ))}
        </div>
      </section>

      <section className="mb-3 compact-section">
        <h6>Languages</h6>
        <div className="d-flex flex-wrap">
          {Array.isArray(k.languages) &&
            k.languages.map((l: any, idx: number) => (
              <Badge bg="light" key={idx} className="me-1 mb-1 compact-badge text-dark">
                {l.name}{' '}
                <small className="text-muted">{l.status ? `(${l.status})` : `(${l.level}/5)`}</small>
              </Badge>
            ))}
        </div>
      </section>

      <section className="mb-3">
        <h6>Certifications</h6>
        <ul className="list-unstyled small">
          {Array.isArray(k.certifications) &&
            k.certifications.map((c: any, idx: number) => (
              <li key={idx} className="mb-1">
                {c.name} {c.issuer ? <span className="text-muted">• {c.issuer}</span> : null}{' '}
                {c.year ? <span className="text-muted">({c.year})</span> : null}
              </li>
            ))}
        </ul>
      </section>

      <section className="mb-3">
        <h6>Tools / Platforms</h6>
        <div className="d-flex flex-wrap">
          {Array.isArray(k.tools) &&
            k.tools.map((t: string, idx: number) => (
              <Badge bg="secondary" key={idx} className="me-1 mb-1">
                {t}
              </Badge>
            ))}
        </div>
      </section>

      <section className="mb-3">
        <h6>Domains & Roles</h6>
        <div className="d-flex flex-wrap mb-2">
          {Array.isArray(k.domains) &&
            k.domains.map((d: string, idx: number) => (
              <Badge bg="info" key={idx} className="me-1 mb-1 text-dark">
                {d}
              </Badge>
            ))}
        </div>
        <div className="d-flex flex-wrap">
          {Array.isArray(k.roles) &&
            k.roles.map((r: string, idx: number) => (
              <Badge bg="light" key={idx} className="me-1 mb-1 text-dark">
                {r}
              </Badge>
            ))}
        </div>
      </section>

      <section className="mb-3 no-print">
        <details>
          <summary className="mb-2">
            ATS Keywords ({Array.isArray(k.atsKeywords) ? k.atsKeywords.length : 0})
          </summary>
          <div className="d-flex flex-wrap">
            {Array.isArray(k.atsKeywords) &&
              k.atsKeywords.map((kw: string, idx: number) => (
                <Badge bg="light" key={idx} className="me-1 mb-1 text-dark">
                  {kw}
                </Badge>
              ))}
          </div>
        </details>
      </section>

       <section className="mb-3 print-only">
       
          <h6 className="mb-2">
            ATS Keywords ({Array.isArray(k.atsKeywords) ? k.atsKeywords.length : 0})
          </h6>
          <div className="d-flex flex-wrap">
            {Array.isArray(k.atsKeywords) &&
              k.atsKeywords.map((kw: string, idx: number) => (
                <Badge bg="light" key={idx} className="me-1 mb-1 text-dark">
                  {kw}
                </Badge>
              ))}
          </div>
       
      </section>
    </div>
  );
};

export default KnowledgeViewer;
